import React from "react";

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-dvh bg-gradient-to-br from-slate-900 via-purple-950 to-slate-900 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <img
          src="/img/icons/logo-dark.png"
          alt="Thursday Thirty Logo"
          width={80}
          height={64}
          className="h-16 w-auto animate-pulse"
        />
        <div className="text-white text-lg font-medium">Loading...</div>
        <div className="flex space-x-1">
          <div
            className="w-2 h-2 bg-white rounded-full animate-bounce"
            style={{ animationDelay: "0ms" }}
          ></div>
          <div
            className="w-2 h-2 bg-white rounded-full animate-bounce"
            style={{ animationDelay: "150ms" }}
          ></div>
          <div
            className="w-2 h-2 bg-white rounded-full animate-bounce"
            style={{ animationDelay: "300ms" }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
